import React from 'react';
import {Switch,Route} from 'react-router-dom';
import Ordenes from '../ordenes/Ordenes';
import Clientes from '../clientes/Clientes';
import Catalogo from '../catalogo/Catalogo';
import Usuarios from '../usuarios/Usuarios';
import Recursos from '../recursos/Recursos';
import Manuales from '../recursos/Manuales';
import OrdenDetail from '../ordenes/OrdenDetail';
import Productos from '../productos/Productos';
import ProductDetail from '../productos/ProductDetail';
import GeneratePDF from '../productos/widgets/GeneratePDF';



const RutasAutenticadas = (props) => {
    let {usuario}=props
     if (usuario) {
        if(usuario.user_permissions.length>0 && usuario.user_permissions.some(permission => permission.codename !== "etiquetas")){
            return (
                <Switch>
                    <Route exact path={`${props.path.url}`} component={Ordenes} />
                    <Route exact path={`${props.path.url}/ordenes/:idRuta`} component={Ordenes} />
                    <Route path={`${props.path.url}/ordenes/:idRuta/:numorden`} component={OrdenDetail} />
                    <Route path={`${props.path.url}/recursos`} component={Recursos} />
                    <Route path={`${props.path.url}/manuales`} component={Manuales} />
                    <Route path={`${props.path.url}/clientes`} component={Clientes} />
                </Switch>
            );
        }
        else if (usuario.user_permissions.some(permission => permission.codename === "etiquetas")) {
            return (<Switch>
                <Route exact path={`${props.path.url}/productos`} component={Productos} />
                <Route exact path={`${props.path.url}/productos/:idProducto`} component={ProductDetail} />
                <Route exact path={`${props.path.url}/productsPDF`} component={GeneratePDF} />
                <Route path={`${props.path.url}/recursos`} component={Recursos} />
                <Route path={`${props.path.url}/manuales`} component={Manuales} />
            </Switch>)
        }
        else if(usuario.is_superuser) {
            return (
                <Switch>
                    <Route exact path={`${props.path.url}`} component={Ordenes} />
                    <Route exact path={`${props.path.url}/ordenes/:idRuta`} component={Ordenes} />
                    <Route path={`${props.path.url}/ordenes/:idRuta/:numorden`} component={OrdenDetail} />
                    <Route path={`${props.path.url}/clientes`} component={Clientes} />
                    <Route path={`${props.path.url}/catalogo`} component={Catalogo} />
                    <Route exact path={`${props.path.url}/productos`} component={Productos} />
                    <Route exact path={`${props.path.url}/productos/:idProducto`} component={ProductDetail} />
                    <Route exact path={`${props.path.url}/productsPDF`} component={GeneratePDF} />
                    <Route path={`${props.path.url}/usuarios`} component={Usuarios} />
                    <Route path={`${props.path.url}/recursos`} component={Recursos} />
                    <Route path={`${props.path.url}/manuales`} component={Manuales} />
                </Switch>
            );
        }
    }
    else
    {
        return (
            <Switch>
                   <Route path={`${props.path.url}/recursos`} component={Recursos} />
                  <Route path={`${props.path.url}/manuales`} component={Manuales} />
            </Switch>
        );
    }
    
};

export default RutasAutenticadas;